export default "__VITE_ASSET__8f7ce021__"